import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import ConfirmInformationOnFileAlert from '../../components/FormAlerts/ConfirmInformationOnFileAlert';
import informationOnFileDescription from '../../components/FormDescriptions/InformationOnFileDescription';
import { blankSchema } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['app-status--information-on-file-title'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, ConfirmInformationOnFileAlert),
    ...descriptionUI(informationOnFileDescription),
  },
  schema: blankSchema,
};
